module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-list py-2"
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.email.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[4][2]",
      "isHtml": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.email),
      expression: "input.email"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "email",
      "value": "",
      "placeholder": "abc@abc.com"
    },
    domProps: {
      "value": (_vm.input.email)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.email.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.email,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[4][1]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.email,
      "type": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[4][2]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.password.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[4][3]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.input.password),
      expression: "input.password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "password",
      "value": "",
      "placeholder": "********"
    },
    domProps: {
      "value": (_vm.input.password)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.password.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.password,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[4][3]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.password,
      "type": "alphaNum"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[4][4]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.password,
      "type": "minLength"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[4][5]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row pt-1 form-description-area text-center"
  }, [_c('ul', {
    staticClass: "col-12 list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[4][4]"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-files-o"
  })], 1)])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "row pt-1 form-description-area text-center"
  }, [_c('p', {
    staticClass: "col-12 mb-0"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[4][7]"
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "col-12 list-unstyled text-center"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'password-remind-from',
        params: {}
      }
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[4][8]"
    }
  })], 1)], 1)]), _vm._v(" "), _c('p', {
    staticClass: "col-12"
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[4][9]",
      "isHtml": true
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tryForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[4][5]"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2dbdbf96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/DemoLogin/PageForm.vue
// module id = 686
// module chunks = 0